// Static storefront constants.
// The live product catalog is DB-backed and served from /api/products (see CatalogContext).

export const HERO_IMG = "/brand/hero.jpg";

export const WHATSAPP_NUMBER = "15706667882";
export const FREE_SHIP_THRESHOLD = 150;
export const SHIP_FEE = 8.00;

// Per-item quantity discount tiers (applied per line by vial count)
export const BULK_TIERS = [
  { min: 10, off: 0.15, label: "10+ vials · 15% off" },
  { min: 5, off: 0.1, label: "5+ vials · 10% off" },
];

export const tierFor = (qty) => BULK_TIERS.find((t) => qty >= t.min) || null;
export const unitPriceFor = (price, qty) => {
  const t = tierFor(qty);
  return t ? Math.round(price * (1 - t.off)) : price;
};

// Whole-dollar prices show without cents; totals that include the $7.99 ship fee show cents.
export const money = (n) => (Number.isInteger(Number(n)) ? `$${Number(n)}` : `$${Number(n).toFixed(2)}`);
